import { contentUrl } from '../api'
import { ISI_TRANSCRIPT } from '../app/isiTranscript'

export const MOA = {
  name: 'MOA',
  title: 'MOA',
  mobileType: "mobile",
  content: [
    {
      menuTemplate: "SINGLE",
      menuName: "ROLE OF TYPE 2 INFLAMMATION",
      content: {
        contentTemplate: "IMAGE",
        content: {
          imageList: [{ src: `${contentUrl}/moa/v5/moa-overview@2x.png`, alt: "MOA - Overview @ 2x" }],
          mobileImageList: [{ srcMobile: `${contentUrl}/moa/v5/moa-overview-mobile@2x.png`, alt: "MOA - Overview Mobile @ 2x" }],
        },
      },
    },
    {
      menuTemplate: "SINGLE",
      menuName: "INHIBITION OF IL-4 AND IL-13 SIGNALING",
      content: {
        contentTemplate: "IMAGE",
        content: {
          imageList: [{ src: `${contentUrl}/moa/v5/moa-inhibition@2x.png`, alt: "MOA - Inhibition @ 2x" }],
          mobileImageList: [{ srcMobile: `${contentUrl}/moa/v5/moa-inhibition-mobile@2x.png`, alt: "MOA - Inhibition Mobile @ 2x" }],
        },
      },
    },
    {
      menuTemplate: 'SINGLE',
      menuName: 'MOA VIDEO',
      content: {
        contentTemplate: "VIDEOFULLSCREEN",
        content: {
          showContentHeader: true,
          name: "GO BENEATH THE SURFACE WITH DUPIXENT",
          src: `${contentUrl}/moa/v5/moa-video-dupixent-ad-2021.mp4`,
          poster: `${contentUrl}/moa/v5/moa-video-dupixent-ad-2021-poster.png`,
          jobNumber: '',
          subtitles: {
            src: `${contentUrl}/components/captions1.vtt`,
            label: 'English',
            lang: 'en',
          },
          contentBlockTranscript: {
            openText: 'Open Transcript',
            closeText: 'Close Transcript',
            transcriptCopy: '<p class="top-padding">Atopic dermatitis, or AD, is a systemic inflammatory skin disease characterized by dry, scaly, itchy skin and eczematous lesions. When uncontrolled, the signs and symptoms of moderate-to-severe disease can have potentially debilitating impacts on patients.</p><p>Like some other chronic inflammatory diseases, AD originates in part from dysregulation of the type 2 immune response. The type 2 immune response—which can be thought of as surveillance for tissue barrier sites like the skin and airways—naturally protects against allergens, irritants, and parasites.</p><p>Dysregulation of this response results in systemic inflammation that contributes to AD.</p><p>While various AD phenotypes have been proposed, type 2 inflammation is a major and common pathophysiological factor, irrespective of patient characteristics like age or ethnicity.</p><p>And while patients with AD will present with a mix of lesional and nonlesional skin, even nonlesional skin has underlying inflammation due to chronic activation of a specific immune response.</p><p>The type 2 immune response involves the release of key cytokines from Th2, ILC2, Tc2, and a variety of other cell types.</p><p>Several signaling cytokines, such as IL-4, IL-13, and IL-31, contribute to both the development and perpetuation of type 2 inflammation and clinical disease features of AD.</p><p>Through both distinct and overlapping roles, IL-4 and IL-13 signaling, through the IL-4 receptor alpha, has shown to affect epidermal barrier dysfunction, increased susceptibility to skin infection, and chronic itch—factors that contribute to the development of eczematous skin lesions.</p><p>IL-4 and IL-13 signaling drives chronic type 2 inflammation in two interdependent ways. First, IL-4 drives differentiation and expansion of naïve helper T cells into Th2 cells which amplify the release of type 2 cytokines via a positive feedback mechanism.</p><p>Second, IL-4 and IL-13 increase type 2 cytokine production through the activation of multiple type 2 immune effector cells including Th2, further enhancing a positive feedback loop that contributes to the development of clinical disease features in AD.</p><p>DUPIXENT is a human monoclonal antibody and the first and only biologic to specifically target the IL-4 receptor alpha to inhibit IL-4 and IL-13 signaling.</p><p class="no-break">DUPIXENT helps address underlying type 2 inflammation resulting in decreased expression of type 2 inflammatory genes, decreased hyperplasia, and improved epithelial barrier.</p>',
            isiTranscript: `${ISI_TRANSCRIPT.isiTranscriptCopy}`,
          },
        },
      },
    },
    {
      menuTemplate: "FUNFACTFOOTER",
      menuName: "Did you know?",
      menuBody: "DUPIXENT inhibits the signaling of IL-4 and IL-13<sup>1</sup>",
      hideInMobileSubNav: true,
    },
    {
      menuTemplate: "TEXT",
      menuName: "References",
      menuType: "REFERENCE",
      content: {
        contentTemplate: "IMAGE",
        content: {
          imageList: [{ src: `${contentUrl}/moa/v5/moa-references@2x.png`, alt: "MOA - References @ 2x" }],
          mobileImageList: [{ srcMobile: `${contentUrl}/moa/v5/moa-references-mobile@2x.png`, alt: "MOA - References Mobile @ 2x" }],
        },
      },
    },
  ],
}
